module.exports = __webpack_public_path__ + "assets/img/33_769.d89c9a05.jpg";